module.exports = __webpack_public_path__ + "img/Ac.72320c5e.png";